import React, { useState } from 'react'
import { Text } from 'components/base'

import AnalyticsTable from '../components/AnalyticsTable'
import { UserAvatar } from 'components/Utils/Avatar'
import SwitchableAnalyticsTable from '../components/SwitchableAnalyticsTable'
import providesOrganizationAnalytics from '../dataSync/providesOrganizationAnalytics'
import { getTeamActivityQuery } from 'remote/analytics'

function TeamActivityAnalytics({
  analytics: { topWriters = [], topReaders = [] },
  analyticsFetchState: { loading },
}) {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <section style={{ width: 300, height: 460 }}>
      <Text.Subtitle className="margin-bottom-large">
        Team activity
      </Text.Subtitle>

      <SwitchableAnalyticsTable
        selectedTabIndex={selectedTab}
        onTabSwitched={setSelectedTab}
        tabs={[
          {
            name: 'Top writers',
            renderTab: () => (
              <AnalyticsTable
                loading={loading}
                title="Member"
                secondaryTitle="Edits"
                entries={topWriters}
                renderPlaceholderIcon={() => (
                  <div
                    style={{ height: 24, width: 24, borderRadius: '100%' }}
                    className="radius-full background-shade-50 margin-right-small"
                  />
                )}
                renderRow={entry => {
                  return (
                    <section className="flexbox">
                      <UserAvatar
                        userId={entry.user.id}
                        size="small"
                        className="margin-right-normal"
                        noBorder={true}
                      />
                      <Text.Corpus className="ellipsis">
                        {entry.user.displayName}
                      </Text.Corpus>
                    </section>
                  )
                }}
                renderValue={entry => {
                  return entry.count
                }}
              />
            ),
          },
          {
            name: 'Top readers',
            renderTab: () => (
              <AnalyticsTable
                loading={loading}
                title="Member"
                secondaryTitle="Views"
                entries={topReaders}
                renderPlaceholderIcon={() => (
                  <div
                    style={{ height: 24, width: 24, borderRadius: '100%' }}
                    className="radius-full background-shade-50 margin-right-small"
                  />
                )}
                renderRow={entry => {
                  return (
                    <section className="flexbox">
                      <UserAvatar
                        userId={entry.user.id}
                        size="small"
                        className="margin-right-normal"
                        noBorder={true}
                      />
                      <Text.Corpus className="ellipsis">
                        {entry.user.displayName}
                      </Text.Corpus>
                    </section>
                  )
                }}
                renderValue={entry => {
                  return entry.count
                }}
              />
            ),
          },
        ]}
      />
    </section>
  )
}

export default providesOrganizationAnalytics(getTeamActivityQuery)(
  TeamActivityAnalytics
)
